export const environment = {
  production: true,
  apiUrl: window.location.hostname.includes('xilo-dev')
    ? 'https://api-dev.xilo.io/api/'
    : window.location.hostname.includes('xilo-review-app')
    ? 'https://api-dev.xilo.io/api/'
    : window.location.hostname.includes('xilo-staging')
    ? 'https://xilo-staging-api.herokuapp.com/api/'
    : window.location.hostname.includes('xilo-uat')
    ? 'https://xilo-uat-api.herokuapp.com/api/'
    : 'https://api.xilo.io/api/',
  devApiUrl: 'https://api-dev.xilo.io/api/',
  eventsApiUrl: 'https://events.xilo.io/api',
  stagingApiUrl: 'https://xilo-staging-api.herokuapp.com/api/',
  uatApiUrl: 'https://xilo-uat-api.herokuapp.com/api/',
  localApiUrl: 'http://localhost:3000/api/',
  stripeTestPKey: 'pk_test_8BZV1HDVmH7VBumHF1NwswJv',
  stripePKey: window.location.hostname.includes('xilo-dev') || window.location.hostname.includes('xilo-review-app') ? 'pk_test_8BZV1HDVmH7VBumHF1NwswJv' : 'pk_live_3LxpaM8RR67YSc9xx0Eys34y',
  estatedAPIKey: 'IJL7wFr1XJN7rWJru2i7zNghi1fep1',
  keenProjectId: '5c04243fc9e77c0001255923',
  keenWriteKey:
    'DB616D3A37C1614E65B719BFDEF51E75C907C3B50BBA7A21A84EA5B6678C45C127C10217BD4C95A73067A7E0F4E55DD4B588E593651397FEA9BB51C348D973A83F1A9241678C30DEA11B842FC6FD60B966CF3C1D5612B7F970EEDC47F38FF3B0',
  GOOGLE_MAPS_API_KEY: 'AIzaSyDgGXKw0IC9CXFSK5DziXRXl3z6STfJhC0',
  covieAccessKey: 'ik_zaf22hdfk7glasvg',
  intakeFormUrl: window.location.hostname.includes('xilo-dev') ? 'http://xilo-dev-intake-form.herokuapp.com' : 'https://intake.xilo.io',
  customerFormUrl: window.location.hostname.includes('xilo-dev') ? 'http://xilo-dev-customer-form.herokuapp.com' : 'https://forms.xilo.io',
  workflowsApiUrl: window.location.hostname.includes('xilo-dev')
    ? 'https://workflows-api-dev.xilo.io/api'
    : window.location.hostname.includes('xilo-review-app')
    ? 'https://workflows-api-dev.xilo.io/api'
    : 'https://workflows-api.xilo.io/api',
  sentryDsnClient: 'https://fcfdbe5ebe0ccd924f0b4bd5ce7ee763@o4509450788995072.ingest.us.sentry.io/4509605744869377',
  env: window.location.hostname.includes('xilo-dev') ? 'staging' : 'production'
};
